// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-datatable .p-datatable-tbody > tr.yellow, .p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd.yellow {
    background: yellow;
}

.l-grid {
    flex-grow: 1;
}

.l-grid .p-dataview .p-dataview-header{
    padding: 0.15em 0.25em;
}
.l-params-panel-left {
    display: flex;
    flex-direction: row;
}
.l-params-panel-right {
    display: flex;
    flex-direction: row-reverse;
}
.l-card div p {
    margin: 0;
}
.p-panel-content .p-progress-spinner {
    width: 35px;
    height: 35px;
}
.profile-expanded a {
    color: white;
}
.l-whitewall-body, .l-panel.l-whitewall-panel-header {
    /* max-width: 100ch;
    margin: auto; */
}
.l-whitewall-body-container .l-component {
    /* border: 1px solid black; */
}
.l-whitewall-body-container .p-dataview .p-dataview-content {
    /* background: unset; */
}
.l-whitewall-body-container .l-detail-header.p-panel-header {
    /* background: transparent;
    color: unset;
    border: none; */
}
body.l-whitewall-body-container .l-whitewall-list-panel > div.p-panel-header {
    /* background: #171506;
    color: forestgreen;
    border: 1px solid #000; */
}
body.l-whitewall-body-container .p-panel .p-panel-content {
    /* background: unset;
    color: white;
    border: 1px solid #000; */
}
body.l-whitewall-body-container .p-panel .p-panel-header {
    /* background: #2d2c2a;
    border: 1px solid #000;
    color: unset;
    padding: 5px; */
}
body.l-whitewall-body-container .p-dataview .l-whitewall-list-panel .p-panel-header {
    /* padding: 5px; */
}
.l-editor .p-editor-container .p-editor-toolbar {
  background: #56AFDF2B;
}
`, "",{"version":3,"sources":["webpack://./lino_react/react/components/LinoBody.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,2BAA2B;AAC/B;AACA;IACI,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI;mBACe;AACnB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,uBAAuB;AAC3B;AACA;IACI;;mBAEe;AACnB;AACA;IACI;;6BAEyB;AAC7B;AACA;IACI;;6BAEyB;AAC7B;AACA;IACI;;;mBAGe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;EACE,qBAAqB;AACvB","sourcesContent":[".p-datatable .p-datatable-tbody > tr.yellow, .p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd.yellow {\n    background: yellow;\n}\n\n.l-grid {\n    flex-grow: 1;\n}\n\n.l-grid .p-dataview .p-dataview-header{\n    padding: 0.15em 0.25em;\n}\n.l-params-panel-left {\n    display: flex;\n    flex-direction: row;\n}\n.l-params-panel-right {\n    display: flex;\n    flex-direction: row-reverse;\n}\n.l-card div p {\n    margin: 0;\n}\n.p-panel-content .p-progress-spinner {\n    width: 35px;\n    height: 35px;\n}\n.profile-expanded a {\n    color: white;\n}\n.l-whitewall-body, .l-panel.l-whitewall-panel-header {\n    /* max-width: 100ch;\n    margin: auto; */\n}\n.l-whitewall-body-container .l-component {\n    /* border: 1px solid black; */\n}\n.l-whitewall-body-container .p-dataview .p-dataview-content {\n    /* background: unset; */\n}\n.l-whitewall-body-container .l-detail-header.p-panel-header {\n    /* background: transparent;\n    color: unset;\n    border: none; */\n}\nbody.l-whitewall-body-container .l-whitewall-list-panel > div.p-panel-header {\n    /* background: #171506;\n    color: forestgreen;\n    border: 1px solid #000; */\n}\nbody.l-whitewall-body-container .p-panel .p-panel-content {\n    /* background: unset;\n    color: white;\n    border: 1px solid #000; */\n}\nbody.l-whitewall-body-container .p-panel .p-panel-header {\n    /* background: #2d2c2a;\n    border: 1px solid #000;\n    color: unset;\n    padding: 5px; */\n}\nbody.l-whitewall-body-container .p-dataview .l-whitewall-list-panel .p-panel-header {\n    /* padding: 5px; */\n}\n.l-editor .p-editor-container .p-editor-toolbar {\n  background: #56AFDF2B;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
